/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifiedImport } from './routes/verified'
import { Route as StatusImport } from './routes/status'
import { Route as SsoImport } from './routes/sso'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SignOutImport } from './routes/sign-out'
import { Route as DetectImport } from './routes/detect'
import { Route as CliTokenImport } from './routes/cli-token'
import { Route as CliAuthImport } from './routes/cli-auth'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as SignInIndexImport } from './routes/sign-in.index'
import { Route as SignInForgotImport } from './routes/sign-in.forgot'
import { Route as AccountSelectImport } from './routes/account.select'
import { Route as AppThreatIntelImport } from './routes/_app.threat-intel'
import { Route as AppScheduleImport } from './routes/_app.schedule'
import { Route as AppHomeImport } from './routes/_app.home'
import { Route as AppExecutiveSummaryImport } from './routes/_app.executive-summary'
import { Route as AppDashboardImport } from './routes/_app.dashboard'
import { Route as AppControlMonitorImport } from './routes/_app.control-monitor'
import { Route as AppActivityImport } from './routes/_app.activity'
import { Route as AppAccountImport } from './routes/_app.account'
import { Route as AppThreatIntelIndexImport } from './routes/_app.threat-intel.index'
import { Route as AppDashboardIndexImport } from './routes/_app.dashboard_.index'
import { Route as AppAccountIndexImport } from './routes/_app.account.index'
import { Route as AppThreatIntelImportImport } from './routes/_app.threat-intel.import'
import { Route as AppThreatIntelIdImport } from './routes/_app.threat-intel.$id'
import { Route as AppDashboardThreatsImport } from './routes/_app.dashboard.threats'
import { Route as AppDashboardTestsImport } from './routes/_app.dashboard.tests'
import { Route as AppDashboardNewThreatsImport } from './routes/_app.dashboard.new-threats'
import { Route as AppDashboardNewEndpointsImport } from './routes/_app.dashboard.new-endpoints'
import { Route as AppDashboardEndpointsImport } from './routes/_app.dashboard.endpoints'
import { Route as AppDashboardActiveEndpointsImport } from './routes/_app.dashboard.active-endpoints'
import { Route as AppAccountUsersImport } from './routes/_app.account.users'
import { Route as AppAccountProfileImport } from './routes/_app.account.profile'
import { Route as AppAccountOidcImport } from './routes/_app.account.oidc'
import { Route as AppAccountAlertsImport } from './routes/_app.account.alerts'
import { Route as AppAccountNotificationsIndexImport } from './routes/_app.account.notifications.index'
import { Route as AppAccountIntegrationsIndexImport } from './routes/_app.account.integrations.index'
import { Route as AppThreatIntelImportUploadImport } from './routes/_app.threat-intel.import.upload'
import { Route as AppThreatIntelImportFeedNoticeImport } from './routes/_app.threat-intel.import.feed-notice'
import { Route as AppThreatIntelImportFeedImport } from './routes/_app.threat-intel.import.feed'
import { Route as AppAccountNotificationsNewImport } from './routes/_app.account.notifications.new'
import { Route as AppAccountNotificationsEditIdImport } from './routes/_app.account.notifications.edit.$id'

// Create/Update Routes

const VerifiedRoute = VerifiedImport.update({
  id: '/verified',
  path: '/verified',
  getParentRoute: () => rootRoute,
} as any)

const StatusRoute = StatusImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRoute,
} as any)

const SsoRoute = SsoImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SignOutRoute = SignOutImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRoute,
} as any)

const DetectRoute = DetectImport.update({
  id: '/detect',
  path: '/detect',
  getParentRoute: () => rootRoute,
} as any)

const CliTokenRoute = CliTokenImport.update({
  id: '/cli-token',
  path: '/cli-token',
  getParentRoute: () => rootRoute,
} as any)

const CliAuthRoute = CliAuthImport.update({
  id: '/cli-auth',
  path: '/cli-auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SignInIndexRoute = SignInIndexImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRoute,
} as any)

const SignInForgotRoute = SignInForgotImport.update({
  id: '/sign-in/forgot',
  path: '/sign-in/forgot',
  getParentRoute: () => rootRoute,
} as any)

const AccountSelectRoute = AccountSelectImport.update({
  id: '/account/select',
  path: '/account/select',
  getParentRoute: () => rootRoute,
} as any)

const AppThreatIntelRoute = AppThreatIntelImport.update({
  id: '/threat-intel',
  path: '/threat-intel',
  getParentRoute: () => AppRoute,
} as any)

const AppScheduleRoute = AppScheduleImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any)

const AppHomeRoute = AppHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)

const AppExecutiveSummaryRoute = AppExecutiveSummaryImport.update({
  id: '/executive-summary',
  path: '/executive-summary',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppControlMonitorRoute = AppControlMonitorImport.update({
  id: '/control-monitor',
  path: '/control-monitor',
  getParentRoute: () => AppRoute,
} as any)

const AppActivityRoute = AppActivityImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountRoute = AppAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)

const AppThreatIntelIndexRoute = AppThreatIntelIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppThreatIntelRoute,
} as any)

const AppDashboardIndexRoute = AppDashboardIndexImport.update({
  id: '/dashboard_/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountIndexRoute = AppAccountIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRoute,
} as any)

const AppThreatIntelImportRoute = AppThreatIntelImportImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppThreatIntelRoute,
} as any)

const AppThreatIntelIdRoute = AppThreatIntelIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppThreatIntelRoute,
} as any)

const AppDashboardThreatsRoute = AppDashboardThreatsImport.update({
  id: '/threats',
  path: '/threats',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardTestsRoute = AppDashboardTestsImport.update({
  id: '/tests',
  path: '/tests',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardNewThreatsRoute = AppDashboardNewThreatsImport.update({
  id: '/new-threats',
  path: '/new-threats',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardNewEndpointsRoute = AppDashboardNewEndpointsImport.update({
  id: '/new-endpoints',
  path: '/new-endpoints',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardEndpointsRoute = AppDashboardEndpointsImport.update({
  id: '/endpoints',
  path: '/endpoints',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardActiveEndpointsRoute =
  AppDashboardActiveEndpointsImport.update({
    id: '/active-endpoints',
    path: '/active-endpoints',
    getParentRoute: () => AppDashboardRoute,
  } as any)

const AppAccountUsersRoute = AppAccountUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAccountRoute,
} as any)

const AppAccountProfileRoute = AppAccountProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppAccountRoute,
} as any)

const AppAccountOidcRoute = AppAccountOidcImport.update({
  id: '/oidc',
  path: '/oidc',
  getParentRoute: () => AppAccountRoute,
} as any)

const AppAccountAlertsRoute = AppAccountAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppAccountRoute,
} as any)

const AppAccountNotificationsIndexRoute =
  AppAccountNotificationsIndexImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AppAccountRoute,
  } as any)

const AppAccountIntegrationsIndexRoute =
  AppAccountIntegrationsIndexImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AppAccountRoute,
  } as any)

const AppThreatIntelImportUploadRoute = AppThreatIntelImportUploadImport.update(
  {
    id: '/upload',
    path: '/upload',
    getParentRoute: () => AppThreatIntelImportRoute,
  } as any,
)

const AppThreatIntelImportFeedNoticeRoute =
  AppThreatIntelImportFeedNoticeImport.update({
    id: '/feed-notice',
    path: '/feed-notice',
    getParentRoute: () => AppThreatIntelImportRoute,
  } as any)

const AppThreatIntelImportFeedRoute = AppThreatIntelImportFeedImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => AppThreatIntelImportRoute,
} as any)

const AppAccountNotificationsNewRoute = AppAccountNotificationsNewImport.update(
  {
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => AppAccountRoute,
  } as any,
)

const AppAccountNotificationsEditIdRoute =
  AppAccountNotificationsEditIdImport.update({
    id: '/notifications/edit/$id',
    path: '/notifications/edit/$id',
    getParentRoute: () => AppAccountRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/cli-auth': {
      id: '/cli-auth'
      path: '/cli-auth'
      fullPath: '/cli-auth'
      preLoaderRoute: typeof CliAuthImport
      parentRoute: typeof rootRoute
    }
    '/cli-token': {
      id: '/cli-token'
      path: '/cli-token'
      fullPath: '/cli-token'
      preLoaderRoute: typeof CliTokenImport
      parentRoute: typeof rootRoute
    }
    '/detect': {
      id: '/detect'
      path: '/detect'
      fullPath: '/detect'
      preLoaderRoute: typeof DetectImport
      parentRoute: typeof rootRoute
    }
    '/sign-out': {
      id: '/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof SignOutImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/sso': {
      id: '/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoImport
      parentRoute: typeof rootRoute
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusImport
      parentRoute: typeof rootRoute
    }
    '/verified': {
      id: '/verified'
      path: '/verified'
      fullPath: '/verified'
      preLoaderRoute: typeof VerifiedImport
      parentRoute: typeof rootRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountImport
      parentRoute: typeof AppImport
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityImport
      parentRoute: typeof AppImport
    }
    '/_app/control-monitor': {
      id: '/_app/control-monitor'
      path: '/control-monitor'
      fullPath: '/control-monitor'
      preLoaderRoute: typeof AppControlMonitorImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/executive-summary': {
      id: '/_app/executive-summary'
      path: '/executive-summary'
      fullPath: '/executive-summary'
      preLoaderRoute: typeof AppExecutiveSummaryImport
      parentRoute: typeof AppImport
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeImport
      parentRoute: typeof AppImport
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleImport
      parentRoute: typeof AppImport
    }
    '/_app/threat-intel': {
      id: '/_app/threat-intel'
      path: '/threat-intel'
      fullPath: '/threat-intel'
      preLoaderRoute: typeof AppThreatIntelImport
      parentRoute: typeof AppImport
    }
    '/account/select': {
      id: '/account/select'
      path: '/account/select'
      fullPath: '/account/select'
      preLoaderRoute: typeof AccountSelectImport
      parentRoute: typeof rootRoute
    }
    '/sign-in/forgot': {
      id: '/sign-in/forgot'
      path: '/sign-in/forgot'
      fullPath: '/sign-in/forgot'
      preLoaderRoute: typeof SignInForgotImport
      parentRoute: typeof rootRoute
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/account/alerts': {
      id: '/_app/account/alerts'
      path: '/alerts'
      fullPath: '/account/alerts'
      preLoaderRoute: typeof AppAccountAlertsImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/account/oidc': {
      id: '/_app/account/oidc'
      path: '/oidc'
      fullPath: '/account/oidc'
      preLoaderRoute: typeof AppAccountOidcImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/account/profile': {
      id: '/_app/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AppAccountProfileImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/account/users': {
      id: '/_app/account/users'
      path: '/users'
      fullPath: '/account/users'
      preLoaderRoute: typeof AppAccountUsersImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/dashboard/active-endpoints': {
      id: '/_app/dashboard/active-endpoints'
      path: '/active-endpoints'
      fullPath: '/dashboard/active-endpoints'
      preLoaderRoute: typeof AppDashboardActiveEndpointsImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/endpoints': {
      id: '/_app/dashboard/endpoints'
      path: '/endpoints'
      fullPath: '/dashboard/endpoints'
      preLoaderRoute: typeof AppDashboardEndpointsImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/new-endpoints': {
      id: '/_app/dashboard/new-endpoints'
      path: '/new-endpoints'
      fullPath: '/dashboard/new-endpoints'
      preLoaderRoute: typeof AppDashboardNewEndpointsImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/new-threats': {
      id: '/_app/dashboard/new-threats'
      path: '/new-threats'
      fullPath: '/dashboard/new-threats'
      preLoaderRoute: typeof AppDashboardNewThreatsImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/tests': {
      id: '/_app/dashboard/tests'
      path: '/tests'
      fullPath: '/dashboard/tests'
      preLoaderRoute: typeof AppDashboardTestsImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/threats': {
      id: '/_app/dashboard/threats'
      path: '/threats'
      fullPath: '/dashboard/threats'
      preLoaderRoute: typeof AppDashboardThreatsImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/threat-intel/$id': {
      id: '/_app/threat-intel/$id'
      path: '/$id'
      fullPath: '/threat-intel/$id'
      preLoaderRoute: typeof AppThreatIntelIdImport
      parentRoute: typeof AppThreatIntelImport
    }
    '/_app/threat-intel/import': {
      id: '/_app/threat-intel/import'
      path: '/import'
      fullPath: '/threat-intel/import'
      preLoaderRoute: typeof AppThreatIntelImportImport
      parentRoute: typeof AppThreatIntelImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/dashboard_/': {
      id: '/_app/dashboard_/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/threat-intel/': {
      id: '/_app/threat-intel/'
      path: '/'
      fullPath: '/threat-intel/'
      preLoaderRoute: typeof AppThreatIntelIndexImport
      parentRoute: typeof AppThreatIntelImport
    }
    '/_app/account/notifications/new': {
      id: '/_app/account/notifications/new'
      path: '/notifications/new'
      fullPath: '/account/notifications/new'
      preLoaderRoute: typeof AppAccountNotificationsNewImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/threat-intel/import/feed': {
      id: '/_app/threat-intel/import/feed'
      path: '/feed'
      fullPath: '/threat-intel/import/feed'
      preLoaderRoute: typeof AppThreatIntelImportFeedImport
      parentRoute: typeof AppThreatIntelImportImport
    }
    '/_app/threat-intel/import/feed-notice': {
      id: '/_app/threat-intel/import/feed-notice'
      path: '/feed-notice'
      fullPath: '/threat-intel/import/feed-notice'
      preLoaderRoute: typeof AppThreatIntelImportFeedNoticeImport
      parentRoute: typeof AppThreatIntelImportImport
    }
    '/_app/threat-intel/import/upload': {
      id: '/_app/threat-intel/import/upload'
      path: '/upload'
      fullPath: '/threat-intel/import/upload'
      preLoaderRoute: typeof AppThreatIntelImportUploadImport
      parentRoute: typeof AppThreatIntelImportImport
    }
    '/_app/account/integrations/': {
      id: '/_app/account/integrations/'
      path: '/integrations'
      fullPath: '/account/integrations'
      preLoaderRoute: typeof AppAccountIntegrationsIndexImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/account/notifications/': {
      id: '/_app/account/notifications/'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AppAccountNotificationsIndexImport
      parentRoute: typeof AppAccountImport
    }
    '/_app/account/notifications/edit/$id': {
      id: '/_app/account/notifications/edit/$id'
      path: '/notifications/edit/$id'
      fullPath: '/account/notifications/edit/$id'
      preLoaderRoute: typeof AppAccountNotificationsEditIdImport
      parentRoute: typeof AppAccountImport
    }
  }
}

// Create and export the route tree

interface AppAccountRouteChildren {
  AppAccountAlertsRoute: typeof AppAccountAlertsRoute
  AppAccountOidcRoute: typeof AppAccountOidcRoute
  AppAccountProfileRoute: typeof AppAccountProfileRoute
  AppAccountUsersRoute: typeof AppAccountUsersRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppAccountNotificationsNewRoute: typeof AppAccountNotificationsNewRoute
  AppAccountIntegrationsIndexRoute: typeof AppAccountIntegrationsIndexRoute
  AppAccountNotificationsIndexRoute: typeof AppAccountNotificationsIndexRoute
  AppAccountNotificationsEditIdRoute: typeof AppAccountNotificationsEditIdRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountAlertsRoute: AppAccountAlertsRoute,
  AppAccountOidcRoute: AppAccountOidcRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAccountUsersRoute: AppAccountUsersRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppAccountNotificationsNewRoute: AppAccountNotificationsNewRoute,
  AppAccountIntegrationsIndexRoute: AppAccountIntegrationsIndexRoute,
  AppAccountNotificationsIndexRoute: AppAccountNotificationsIndexRoute,
  AppAccountNotificationsEditIdRoute: AppAccountNotificationsEditIdRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppDashboardRouteChildren {
  AppDashboardActiveEndpointsRoute: typeof AppDashboardActiveEndpointsRoute
  AppDashboardEndpointsRoute: typeof AppDashboardEndpointsRoute
  AppDashboardNewEndpointsRoute: typeof AppDashboardNewEndpointsRoute
  AppDashboardNewThreatsRoute: typeof AppDashboardNewThreatsRoute
  AppDashboardTestsRoute: typeof AppDashboardTestsRoute
  AppDashboardThreatsRoute: typeof AppDashboardThreatsRoute
}

const AppDashboardRouteChildren: AppDashboardRouteChildren = {
  AppDashboardActiveEndpointsRoute: AppDashboardActiveEndpointsRoute,
  AppDashboardEndpointsRoute: AppDashboardEndpointsRoute,
  AppDashboardNewEndpointsRoute: AppDashboardNewEndpointsRoute,
  AppDashboardNewThreatsRoute: AppDashboardNewThreatsRoute,
  AppDashboardTestsRoute: AppDashboardTestsRoute,
  AppDashboardThreatsRoute: AppDashboardThreatsRoute,
}

const AppDashboardRouteWithChildren = AppDashboardRoute._addFileChildren(
  AppDashboardRouteChildren,
)

interface AppThreatIntelImportRouteChildren {
  AppThreatIntelImportFeedRoute: typeof AppThreatIntelImportFeedRoute
  AppThreatIntelImportFeedNoticeRoute: typeof AppThreatIntelImportFeedNoticeRoute
  AppThreatIntelImportUploadRoute: typeof AppThreatIntelImportUploadRoute
}

const AppThreatIntelImportRouteChildren: AppThreatIntelImportRouteChildren = {
  AppThreatIntelImportFeedRoute: AppThreatIntelImportFeedRoute,
  AppThreatIntelImportFeedNoticeRoute: AppThreatIntelImportFeedNoticeRoute,
  AppThreatIntelImportUploadRoute: AppThreatIntelImportUploadRoute,
}

const AppThreatIntelImportRouteWithChildren =
  AppThreatIntelImportRoute._addFileChildren(AppThreatIntelImportRouteChildren)

interface AppThreatIntelRouteChildren {
  AppThreatIntelIdRoute: typeof AppThreatIntelIdRoute
  AppThreatIntelImportRoute: typeof AppThreatIntelImportRouteWithChildren
  AppThreatIntelIndexRoute: typeof AppThreatIntelIndexRoute
}

const AppThreatIntelRouteChildren: AppThreatIntelRouteChildren = {
  AppThreatIntelIdRoute: AppThreatIntelIdRoute,
  AppThreatIntelImportRoute: AppThreatIntelImportRouteWithChildren,
  AppThreatIntelIndexRoute: AppThreatIntelIndexRoute,
}

const AppThreatIntelRouteWithChildren = AppThreatIntelRoute._addFileChildren(
  AppThreatIntelRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppActivityRoute: typeof AppActivityRoute
  AppControlMonitorRoute: typeof AppControlMonitorRoute
  AppDashboardRoute: typeof AppDashboardRouteWithChildren
  AppExecutiveSummaryRoute: typeof AppExecutiveSummaryRoute
  AppHomeRoute: typeof AppHomeRoute
  AppScheduleRoute: typeof AppScheduleRoute
  AppThreatIntelRoute: typeof AppThreatIntelRouteWithChildren
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppActivityRoute: AppActivityRoute,
  AppControlMonitorRoute: AppControlMonitorRoute,
  AppDashboardRoute: AppDashboardRouteWithChildren,
  AppExecutiveSummaryRoute: AppExecutiveSummaryRoute,
  AppHomeRoute: AppHomeRoute,
  AppScheduleRoute: AppScheduleRoute,
  AppThreatIntelRoute: AppThreatIntelRouteWithChildren,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AppRouteWithChildren
  '/cli-auth': typeof CliAuthRoute
  '/cli-token': typeof CliTokenRoute
  '/detect': typeof DetectRoute
  '/sign-out': typeof SignOutRoute
  '/sign-up': typeof SignUpRoute
  '/sso': typeof SsoRoute
  '/status': typeof StatusRoute
  '/verified': typeof VerifiedRoute
  '/account': typeof AppAccountRouteWithChildren
  '/activity': typeof AppActivityRoute
  '/control-monitor': typeof AppControlMonitorRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/executive-summary': typeof AppExecutiveSummaryRoute
  '/home': typeof AppHomeRoute
  '/schedule': typeof AppScheduleRoute
  '/threat-intel': typeof AppThreatIntelRouteWithChildren
  '/account/select': typeof AccountSelectRoute
  '/sign-in/forgot': typeof SignInForgotRoute
  '/sign-in': typeof SignInIndexRoute
  '/account/alerts': typeof AppAccountAlertsRoute
  '/account/oidc': typeof AppAccountOidcRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/account/users': typeof AppAccountUsersRoute
  '/dashboard/active-endpoints': typeof AppDashboardActiveEndpointsRoute
  '/dashboard/endpoints': typeof AppDashboardEndpointsRoute
  '/dashboard/new-endpoints': typeof AppDashboardNewEndpointsRoute
  '/dashboard/new-threats': typeof AppDashboardNewThreatsRoute
  '/dashboard/tests': typeof AppDashboardTestsRoute
  '/dashboard/threats': typeof AppDashboardThreatsRoute
  '/threat-intel/$id': typeof AppThreatIntelIdRoute
  '/threat-intel/import': typeof AppThreatIntelImportRouteWithChildren
  '/account/': typeof AppAccountIndexRoute
  '/threat-intel/': typeof AppThreatIntelIndexRoute
  '/account/notifications/new': typeof AppAccountNotificationsNewRoute
  '/threat-intel/import/feed': typeof AppThreatIntelImportFeedRoute
  '/threat-intel/import/feed-notice': typeof AppThreatIntelImportFeedNoticeRoute
  '/threat-intel/import/upload': typeof AppThreatIntelImportUploadRoute
  '/account/integrations': typeof AppAccountIntegrationsIndexRoute
  '/account/notifications': typeof AppAccountNotificationsIndexRoute
  '/account/notifications/edit/$id': typeof AppAccountNotificationsEditIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AppRouteWithChildren
  '/cli-auth': typeof CliAuthRoute
  '/cli-token': typeof CliTokenRoute
  '/detect': typeof DetectRoute
  '/sign-out': typeof SignOutRoute
  '/sign-up': typeof SignUpRoute
  '/sso': typeof SsoRoute
  '/status': typeof StatusRoute
  '/verified': typeof VerifiedRoute
  '/activity': typeof AppActivityRoute
  '/control-monitor': typeof AppControlMonitorRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/executive-summary': typeof AppExecutiveSummaryRoute
  '/home': typeof AppHomeRoute
  '/schedule': typeof AppScheduleRoute
  '/account/select': typeof AccountSelectRoute
  '/sign-in/forgot': typeof SignInForgotRoute
  '/sign-in': typeof SignInIndexRoute
  '/account/alerts': typeof AppAccountAlertsRoute
  '/account/oidc': typeof AppAccountOidcRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/account/users': typeof AppAccountUsersRoute
  '/dashboard/active-endpoints': typeof AppDashboardActiveEndpointsRoute
  '/dashboard/endpoints': typeof AppDashboardEndpointsRoute
  '/dashboard/new-endpoints': typeof AppDashboardNewEndpointsRoute
  '/dashboard/new-threats': typeof AppDashboardNewThreatsRoute
  '/dashboard/tests': typeof AppDashboardTestsRoute
  '/dashboard/threats': typeof AppDashboardThreatsRoute
  '/threat-intel/$id': typeof AppThreatIntelIdRoute
  '/threat-intel/import': typeof AppThreatIntelImportRouteWithChildren
  '/account': typeof AppAccountIndexRoute
  '/threat-intel': typeof AppThreatIntelIndexRoute
  '/account/notifications/new': typeof AppAccountNotificationsNewRoute
  '/threat-intel/import/feed': typeof AppThreatIntelImportFeedRoute
  '/threat-intel/import/feed-notice': typeof AppThreatIntelImportFeedNoticeRoute
  '/threat-intel/import/upload': typeof AppThreatIntelImportUploadRoute
  '/account/integrations': typeof AppAccountIntegrationsIndexRoute
  '/account/notifications': typeof AppAccountNotificationsIndexRoute
  '/account/notifications/edit/$id': typeof AppAccountNotificationsEditIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/cli-auth': typeof CliAuthRoute
  '/cli-token': typeof CliTokenRoute
  '/detect': typeof DetectRoute
  '/sign-out': typeof SignOutRoute
  '/sign-up': typeof SignUpRoute
  '/sso': typeof SsoRoute
  '/status': typeof StatusRoute
  '/verified': typeof VerifiedRoute
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/activity': typeof AppActivityRoute
  '/_app/control-monitor': typeof AppControlMonitorRoute
  '/_app/dashboard': typeof AppDashboardRouteWithChildren
  '/_app/executive-summary': typeof AppExecutiveSummaryRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/schedule': typeof AppScheduleRoute
  '/_app/threat-intel': typeof AppThreatIntelRouteWithChildren
  '/account/select': typeof AccountSelectRoute
  '/sign-in/forgot': typeof SignInForgotRoute
  '/sign-in/': typeof SignInIndexRoute
  '/_app/account/alerts': typeof AppAccountAlertsRoute
  '/_app/account/oidc': typeof AppAccountOidcRoute
  '/_app/account/profile': typeof AppAccountProfileRoute
  '/_app/account/users': typeof AppAccountUsersRoute
  '/_app/dashboard/active-endpoints': typeof AppDashboardActiveEndpointsRoute
  '/_app/dashboard/endpoints': typeof AppDashboardEndpointsRoute
  '/_app/dashboard/new-endpoints': typeof AppDashboardNewEndpointsRoute
  '/_app/dashboard/new-threats': typeof AppDashboardNewThreatsRoute
  '/_app/dashboard/tests': typeof AppDashboardTestsRoute
  '/_app/dashboard/threats': typeof AppDashboardThreatsRoute
  '/_app/threat-intel/$id': typeof AppThreatIntelIdRoute
  '/_app/threat-intel/import': typeof AppThreatIntelImportRouteWithChildren
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/dashboard_/': typeof AppDashboardIndexRoute
  '/_app/threat-intel/': typeof AppThreatIntelIndexRoute
  '/_app/account/notifications/new': typeof AppAccountNotificationsNewRoute
  '/_app/threat-intel/import/feed': typeof AppThreatIntelImportFeedRoute
  '/_app/threat-intel/import/feed-notice': typeof AppThreatIntelImportFeedNoticeRoute
  '/_app/threat-intel/import/upload': typeof AppThreatIntelImportUploadRoute
  '/_app/account/integrations/': typeof AppAccountIntegrationsIndexRoute
  '/_app/account/notifications/': typeof AppAccountNotificationsIndexRoute
  '/_app/account/notifications/edit/$id': typeof AppAccountNotificationsEditIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/cli-auth'
    | '/cli-token'
    | '/detect'
    | '/sign-out'
    | '/sign-up'
    | '/sso'
    | '/status'
    | '/verified'
    | '/account'
    | '/activity'
    | '/control-monitor'
    | '/dashboard'
    | '/executive-summary'
    | '/home'
    | '/schedule'
    | '/threat-intel'
    | '/account/select'
    | '/sign-in/forgot'
    | '/sign-in'
    | '/account/alerts'
    | '/account/oidc'
    | '/account/profile'
    | '/account/users'
    | '/dashboard/active-endpoints'
    | '/dashboard/endpoints'
    | '/dashboard/new-endpoints'
    | '/dashboard/new-threats'
    | '/dashboard/tests'
    | '/dashboard/threats'
    | '/threat-intel/$id'
    | '/threat-intel/import'
    | '/account/'
    | '/threat-intel/'
    | '/account/notifications/new'
    | '/threat-intel/import/feed'
    | '/threat-intel/import/feed-notice'
    | '/threat-intel/import/upload'
    | '/account/integrations'
    | '/account/notifications'
    | '/account/notifications/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/cli-auth'
    | '/cli-token'
    | '/detect'
    | '/sign-out'
    | '/sign-up'
    | '/sso'
    | '/status'
    | '/verified'
    | '/activity'
    | '/control-monitor'
    | '/dashboard'
    | '/executive-summary'
    | '/home'
    | '/schedule'
    | '/account/select'
    | '/sign-in/forgot'
    | '/sign-in'
    | '/account/alerts'
    | '/account/oidc'
    | '/account/profile'
    | '/account/users'
    | '/dashboard/active-endpoints'
    | '/dashboard/endpoints'
    | '/dashboard/new-endpoints'
    | '/dashboard/new-threats'
    | '/dashboard/tests'
    | '/dashboard/threats'
    | '/threat-intel/$id'
    | '/threat-intel/import'
    | '/account'
    | '/threat-intel'
    | '/account/notifications/new'
    | '/threat-intel/import/feed'
    | '/threat-intel/import/feed-notice'
    | '/threat-intel/import/upload'
    | '/account/integrations'
    | '/account/notifications'
    | '/account/notifications/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/cli-auth'
    | '/cli-token'
    | '/detect'
    | '/sign-out'
    | '/sign-up'
    | '/sso'
    | '/status'
    | '/verified'
    | '/_app/account'
    | '/_app/activity'
    | '/_app/control-monitor'
    | '/_app/dashboard'
    | '/_app/executive-summary'
    | '/_app/home'
    | '/_app/schedule'
    | '/_app/threat-intel'
    | '/account/select'
    | '/sign-in/forgot'
    | '/sign-in/'
    | '/_app/account/alerts'
    | '/_app/account/oidc'
    | '/_app/account/profile'
    | '/_app/account/users'
    | '/_app/dashboard/active-endpoints'
    | '/_app/dashboard/endpoints'
    | '/_app/dashboard/new-endpoints'
    | '/_app/dashboard/new-threats'
    | '/_app/dashboard/tests'
    | '/_app/dashboard/threats'
    | '/_app/threat-intel/$id'
    | '/_app/threat-intel/import'
    | '/_app/account/'
    | '/_app/dashboard_/'
    | '/_app/threat-intel/'
    | '/_app/account/notifications/new'
    | '/_app/threat-intel/import/feed'
    | '/_app/threat-intel/import/feed-notice'
    | '/_app/threat-intel/import/upload'
    | '/_app/account/integrations/'
    | '/_app/account/notifications/'
    | '/_app/account/notifications/edit/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CliAuthRoute: typeof CliAuthRoute
  CliTokenRoute: typeof CliTokenRoute
  DetectRoute: typeof DetectRoute
  SignOutRoute: typeof SignOutRoute
  SignUpRoute: typeof SignUpRoute
  SsoRoute: typeof SsoRoute
  StatusRoute: typeof StatusRoute
  VerifiedRoute: typeof VerifiedRoute
  AccountSelectRoute: typeof AccountSelectRoute
  SignInForgotRoute: typeof SignInForgotRoute
  SignInIndexRoute: typeof SignInIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CliAuthRoute: CliAuthRoute,
  CliTokenRoute: CliTokenRoute,
  DetectRoute: DetectRoute,
  SignOutRoute: SignOutRoute,
  SignUpRoute: SignUpRoute,
  SsoRoute: SsoRoute,
  StatusRoute: StatusRoute,
  VerifiedRoute: VerifiedRoute,
  AccountSelectRoute: AccountSelectRoute,
  SignInForgotRoute: SignInForgotRoute,
  SignInIndexRoute: SignInIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/cli-auth",
        "/cli-token",
        "/detect",
        "/sign-out",
        "/sign-up",
        "/sso",
        "/status",
        "/verified",
        "/account/select",
        "/sign-in/forgot",
        "/sign-in/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/account",
        "/_app/activity",
        "/_app/control-monitor",
        "/_app/dashboard",
        "/_app/executive-summary",
        "/_app/home",
        "/_app/schedule",
        "/_app/threat-intel",
        "/_app/dashboard_/"
      ]
    },
    "/cli-auth": {
      "filePath": "cli-auth.tsx"
    },
    "/cli-token": {
      "filePath": "cli-token.tsx"
    },
    "/detect": {
      "filePath": "detect.tsx"
    },
    "/sign-out": {
      "filePath": "sign-out.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/sso": {
      "filePath": "sso.tsx"
    },
    "/status": {
      "filePath": "status.tsx"
    },
    "/verified": {
      "filePath": "verified.tsx"
    },
    "/_app/account": {
      "filePath": "_app.account.tsx",
      "parent": "/_app",
      "children": [
        "/_app/account/alerts",
        "/_app/account/oidc",
        "/_app/account/profile",
        "/_app/account/users",
        "/_app/account/",
        "/_app/account/notifications/new",
        "/_app/account/integrations/",
        "/_app/account/notifications/",
        "/_app/account/notifications/edit/$id"
      ]
    },
    "/_app/activity": {
      "filePath": "_app.activity.tsx",
      "parent": "/_app"
    },
    "/_app/control-monitor": {
      "filePath": "_app.control-monitor.tsx",
      "parent": "/_app"
    },
    "/_app/dashboard": {
      "filePath": "_app.dashboard.tsx",
      "parent": "/_app",
      "children": [
        "/_app/dashboard/active-endpoints",
        "/_app/dashboard/endpoints",
        "/_app/dashboard/new-endpoints",
        "/_app/dashboard/new-threats",
        "/_app/dashboard/tests",
        "/_app/dashboard/threats"
      ]
    },
    "/_app/executive-summary": {
      "filePath": "_app.executive-summary.tsx",
      "parent": "/_app"
    },
    "/_app/home": {
      "filePath": "_app.home.tsx",
      "parent": "/_app"
    },
    "/_app/schedule": {
      "filePath": "_app.schedule.tsx",
      "parent": "/_app"
    },
    "/_app/threat-intel": {
      "filePath": "_app.threat-intel.tsx",
      "parent": "/_app",
      "children": [
        "/_app/threat-intel/$id",
        "/_app/threat-intel/import",
        "/_app/threat-intel/"
      ]
    },
    "/account/select": {
      "filePath": "account.select.tsx"
    },
    "/sign-in/forgot": {
      "filePath": "sign-in.forgot.tsx"
    },
    "/sign-in/": {
      "filePath": "sign-in.index.tsx"
    },
    "/_app/account/alerts": {
      "filePath": "_app.account.alerts.tsx",
      "parent": "/_app/account"
    },
    "/_app/account/oidc": {
      "filePath": "_app.account.oidc.tsx",
      "parent": "/_app/account"
    },
    "/_app/account/profile": {
      "filePath": "_app.account.profile.tsx",
      "parent": "/_app/account"
    },
    "/_app/account/users": {
      "filePath": "_app.account.users.tsx",
      "parent": "/_app/account"
    },
    "/_app/dashboard/active-endpoints": {
      "filePath": "_app.dashboard.active-endpoints.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/endpoints": {
      "filePath": "_app.dashboard.endpoints.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/new-endpoints": {
      "filePath": "_app.dashboard.new-endpoints.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/new-threats": {
      "filePath": "_app.dashboard.new-threats.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/tests": {
      "filePath": "_app.dashboard.tests.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/threats": {
      "filePath": "_app.dashboard.threats.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/threat-intel/$id": {
      "filePath": "_app.threat-intel.$id.tsx",
      "parent": "/_app/threat-intel"
    },
    "/_app/threat-intel/import": {
      "filePath": "_app.threat-intel.import.tsx",
      "parent": "/_app/threat-intel",
      "children": [
        "/_app/threat-intel/import/feed",
        "/_app/threat-intel/import/feed-notice",
        "/_app/threat-intel/import/upload"
      ]
    },
    "/_app/account/": {
      "filePath": "_app.account.index.tsx",
      "parent": "/_app/account"
    },
    "/_app/dashboard_/": {
      "filePath": "_app.dashboard_.index.tsx",
      "parent": "/_app"
    },
    "/_app/threat-intel/": {
      "filePath": "_app.threat-intel.index.tsx",
      "parent": "/_app/threat-intel"
    },
    "/_app/account/notifications/new": {
      "filePath": "_app.account.notifications.new.tsx",
      "parent": "/_app/account"
    },
    "/_app/threat-intel/import/feed": {
      "filePath": "_app.threat-intel.import.feed.tsx",
      "parent": "/_app/threat-intel/import"
    },
    "/_app/threat-intel/import/feed-notice": {
      "filePath": "_app.threat-intel.import.feed-notice.tsx",
      "parent": "/_app/threat-intel/import"
    },
    "/_app/threat-intel/import/upload": {
      "filePath": "_app.threat-intel.import.upload.tsx",
      "parent": "/_app/threat-intel/import"
    },
    "/_app/account/integrations/": {
      "filePath": "_app.account.integrations.index.tsx",
      "parent": "/_app/account"
    },
    "/_app/account/notifications/": {
      "filePath": "_app.account.notifications.index.tsx",
      "parent": "/_app/account"
    },
    "/_app/account/notifications/edit/$id": {
      "filePath": "_app.account.notifications.edit.$id.tsx",
      "parent": "/_app/account"
    }
  }
}
ROUTE_MANIFEST_END */
